module.exports = __webpack_public_path__ + "img/ico-circle-arrow-right.08b3cb12.svg";